import { useDispatch, useSelector } from 'react-redux';
import { StoreRootState } from 'services/store/types';
import type { UserStore } from '../../store/user/types';
import { checkLoadingSelector } from '../../store/base/selectors';
import userActions from '../../store/user/actions/constants';
import {
  newSongsInLibraryFlagReset,
  setSongListPosition,
  songsLibrary,
  songsLibraryReset,
} from '../../store/user/actions/actionCreators';

type UseUserStore = {
  userStore: UserStore;
  isGetSongsLoading: boolean;
  getSongs: (page: number) => void;
  resetSongs: () => void;
  resetNewSongsInLibraryFlag: () => void;
  saveScrollPosition: (pos: number) => void;
};

const useUserStore = (): UseUserStore => {
  const dispatch = useDispatch();
  const baseStore = useSelector((store: StoreRootState) => store.base);
  const userStore = useSelector((store: StoreRootState) => store.user);

  return {
    userStore,
    isGetSongsLoading: checkLoadingSelector(baseStore, [
      userActions.USER_LIBRARY,
    ]),
    getSongs: (page: number, unifiedLibraryStructure = true): void => {
      dispatch(
        songsLibrary({
          page,
          unifiedLibraryStructure,
        })
      );
    },
    resetSongs: (): void => {
      dispatch(songsLibraryReset());
    },
    resetNewSongsInLibraryFlag: (): void => {
      dispatch(newSongsInLibraryFlagReset());
    },
    saveScrollPosition: (pos): void => {
      dispatch(setSongListPosition({ position: pos }));
    },
  };
};

export default useUserStore;
